import * as React from 'react'
import { Theme, useMediaQuery } from '@mui/material'

export type Props = {
    children?: React.ReactNode
    lgDown?: boolean,
    lgUp?: boolean
    mdDown?: boolean
    mdUp?: boolean
    smDown?: boolean
    smUp?: boolean
    xlDown?: boolean
    xlUp?: boolean
    xsDown?: boolean
    xsUp?: boolean
    [prop:string]: any
}

export default (props: Props) => {
    let isHidden = useMediaQuery((theme: Theme ) => 
        props.lgDown ? theme.breakpoints.down('lg') :
        props.lgUp ? theme.breakpoints.up('lg') :
        props.mdDown ? theme.breakpoints.down('md') :
        props.mdUp ? theme.breakpoints.up('md') :
        props.smDown ? theme.breakpoints.down('sm') :
        props.smUp ? theme.breakpoints.up('sm') :
        props.xlDown ? theme.breakpoints.down('xl') :
        props.xlUp ? theme.breakpoints.up('xl') :
        props.xsDown ? theme.breakpoints.down('xs') :
        props.xsUp ? theme.breakpoints.up('xs') :
        '@media (max-width: 0px)'
    );

    return isHidden ? <></> : <>{props.children}</>
}